import { render, staticRenderFns } from "./BlockMarket.vue?vue&type=template&id=623a6118&scoped=true"
import script from "./BlockMarket.vue?vue&type=script&lang=js"
export * from "./BlockMarket.vue?vue&type=script&lang=js"
import style0 from "./BlockMarket.vue?vue&type=style&index=0&id=623a6118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a6118",
  null
  
)

export default component.exports